import sendRequest from "./sendRequest";

export const callProcessNotifications = () => {
    return sendRequest("/process_notifications", 'GET');
}
